"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.4.0'] && _();
}
catch (e) { }
